import axios from 'axios'
import config from '@/config'

export default {
    _getBranch() {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get('/profile-branch', {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    _getDepartment(branch) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get('/profile-department/branch/' + branch, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    _getPosition(branch, department) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get('/employee/position', {
            params: {
                'branch': branch,
                'department': department,
                companyid: _company_guid,
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    _getAllEmployeeByBranch(branch,dep) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get('/employee/FilterEmpByBranch', {
            params: {
                'branch': branch,
                'dep': dep,
                companyid: _company_guid,
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
}